import React from "react";
import "./ReturnPolicy.css";

const LastUpdated = "September 7, 2025";

export default function ReturnPolicy() {
  return (
    <main className="navbar-offset return-policy-wrap">
      <article className="return-policy-card">
        <h1>Return & Refund Policy</h1>
        <p className="return-policy-muted">Last updated: {LastUpdated}</p>

        <p>
          At <strong>LankaLearners.lk</strong>, we provide high-quality online
          learning resources. Because our products are delivered digitally, this
          policy explains when refunds are available.
        </p>

        <h2>1. Digital Products</h2>
        <ul>
          <li>
            Once purchased, access to digital content is{" "}
            <strong>non-refundable</strong>, as learners immediately gain full
            access.
          </li>
          <li>Refunds are considered only if:</li>
          <ul>
            <li>There was a duplicate payment due to a technical error, or</li>
            <li>
              Payment succeeded but the service was not delivered due to a
              system issue on our side.
            </li>
          </ul>
        </ul>

        <h2>2. Incorrect Purchases</h2>
        <p>
          Please verify the correct course or service before purchasing. We
          cannot refund purchases made in error.
        </p>

        <h2>3. Technical Issues</h2>
        <p>
          If you face access issues, contact 0712367846 within{" "}
          <strong>7 days</strong> of purchase. We will resolve the issue or
          offer a refund if it cannot be fixed.
        </p>

        <h2>4. Subscriptions</h2>
        <ul>
          <li>You may cancel at any time.</li>
          <li>
            Access remains until the end of the current billing cycle. We do not
            provide partial refunds for unused periods.
          </li>
        </ul>

        <h2>5. Contact Us</h2>
        <p>For refund/payment concerns: 0712367846</p>
      </article>
    </main>
  );
}
